'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "slots", "slotProps", "adapter", "localeText", "variant", "density", "members", "currentUser", "roleDisplayNames", "getMessageAuthorId", "getMessageAuthorDisplayName", "getMessageAuthorAvatarUrl", "messages", "initialMessages", "onMessagesChange", "conversations", "initialConversations", "onConversationsChange", "activeConversationId", "initialActiveConversationId", "onActiveConversationChange", "composerValue", "initialComposerValue", "onComposerValueChange", "onToolCall", "onFinish", "onData", "onError", "streamFlushInterval", "partRenderers", "storeClass", "features"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { ChatProvider } from "../ChatProvider.js";
import { ChatLocaleProvider } from "./internals/ChatLocaleContext.js";
import { ChatVariantProvider } from "./internals/ChatVariantContext.js";
import { ChatDensityProvider } from "./internals/ChatDensityContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ChatRoot = /*#__PURE__*/React.forwardRef(function ChatRoot(props, ref) {
  const isActiveConversationIdControlled = Object.prototype.hasOwnProperty.call(props, 'activeConversationId');
  const {
      children,
      slots,
      slotProps,
      adapter,
      localeText,
      variant,
      density,
      members,
      currentUser,
      roleDisplayNames,
      getMessageAuthorId,
      getMessageAuthorDisplayName,
      getMessageAuthorAvatarUrl,
      messages,
      initialMessages,
      onMessagesChange,
      conversations,
      initialConversations,
      onConversationsChange,
      activeConversationId,
      initialActiveConversationId,
      onActiveConversationChange,
      composerValue,
      initialComposerValue,
      onComposerValueChange,
      onToolCall,
      onFinish,
      onData,
      onError,
      streamFlushInterval,
      partRenderers,
      storeClass,
      features
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const Root = slots?.root ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState: {},
    additionalProps: {
      ref
    }
  });
  return /*#__PURE__*/_jsx(ChatProvider, _extends({
    adapter: adapter,
    members: members,
    currentUser: currentUser,
    getMessageAuthorId: getMessageAuthorId,
    getMessageAuthorDisplayName: getMessageAuthorDisplayName,
    getMessageAuthorAvatarUrl: getMessageAuthorAvatarUrl,
    messages: messages,
    initialMessages: initialMessages,
    onMessagesChange: onMessagesChange,
    conversations: conversations,
    initialConversations: initialConversations,
    onConversationsChange: onConversationsChange
  }, isActiveConversationIdControlled ? {
    activeConversationId
  } : {}, {
    initialActiveConversationId: initialActiveConversationId,
    onActiveConversationChange: onActiveConversationChange,
    composerValue: composerValue,
    initialComposerValue: initialComposerValue,
    onComposerValueChange: onComposerValueChange,
    onToolCall: onToolCall,
    onFinish: onFinish,
    onData: onData,
    onError: onError,
    streamFlushInterval: streamFlushInterval,
    partRenderers: partRenderers,
    storeClass: storeClass,
    roleDisplayNames: roleDisplayNames,
    features: features,
    children: /*#__PURE__*/_jsx(ChatLocaleProvider, {
      localeText: localeText,
      children: (() => {
        let content = /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
          children: children
        }));
        if (variant) {
          content = /*#__PURE__*/_jsx(ChatVariantProvider, {
            variant: variant,
            children: content
          });
        }
        if (density) {
          content = /*#__PURE__*/_jsx(ChatDensityProvider, {
            density: density,
            children: content
          });
        }
        return content;
      })()
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatRoot.displayName = "ChatRoot";